import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/* Einbettungs-Modus für /t/:slug und /v/:slug (?embed=1): reduzierte Ansicht ohne Navigation/Footer/Cookie-Hinweis.
   Höhe wird per postMessage an die einbettende Seite gemeldet – nur an die Herkunft des Referrers (kein „*“, wenn bekannt); die Gegenseite prüft e.origin. */
export const isEmbed = (search) => new URLSearchParams(search || "").get("embed") === "1";

export const isEmbedPath = (pathname, search) => (pathname.startsWith("/t/") || pathname.startsWith("/v/")) && isEmbed(search);

export const useEmbed = () => {
  const { pathname, search } = useLocation();
  const embed = isEmbedPath(pathname, search);
  useEffect(() => {
    if (!embed || window.self === window.top) return undefined;
    let target = "*";
    try { target = document.referrer ? new URL(document.referrer).origin : "*"; } catch { target = "*"; }
    const post = () => window.parent.postMessage({ type: "dimedial-tickets-height", height: Math.ceil(document.documentElement.scrollHeight) }, target);
    post();
    const ro = new ResizeObserver(post);
    ro.observe(document.body);
    window.addEventListener("load", post);
    return () => { ro.disconnect(); window.removeEventListener("load", post); };
  }, [embed]);
  return embed;
};

/* Dezenter Plattformhinweis am Ende der eingebetteten Ansicht – ohne Robbie (öffentliche Käuferseiten). */
export const PoweredBy = ({ compact = false }) => (
  <a href="https://dimedial.studio/tickets" target="_blank" rel="noreferrer" className={`inline-flex items-center gap-2 text-[11px] text-[#4A4A4A] hover:text-[#111] transition-colors ${compact ? "" : "mt-6"}`} data-testid="t-powered-by">
    <span>Ticketing durch <b>DIMEDIAL.studio</b></span>
  </a>
);

/* Schutz vor Einbettung privater/administrativer Seiten: nur /t, /v (mit embed=1), /player, /stele/* dürfen in fremden Frames laufen. */
const EMBEDDABLE = (pathname, search) => isEmbedPath(pathname, search) || pathname === "/player" || pathname.startsWith("/stele/") || (pathname.startsWith("/@") && isEmbed(search));

/* Emergent-Vorschau (App-Builder bettet die Preview-Domain per iframe ein) vom Schutz ausnehmen – nur Preview, nie die Live-Domain. */
const inEmergentPreview = () => { try { return window.location.hostname.includes("emergent"); } catch { return false; } };

export const FrameGuard = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (window.self === window.top || inEmergentPreview() || EMBEDDABLE(pathname, search)) return;
    document.body.innerHTML = "<p style='font:14px system-ui;padding:24px'>Diese Seite kann nicht eingebettet werden. <a href='" + window.location.href + "' target='_top'>Im eigenen Fenster öffnen</a></p>";
    try { window.top.location.replace(window.location.href); } catch { /* fremder Origin – Hinweis bleibt stehen */ }
  }, [pathname, search]);
  return null;
};
